import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { logFirebaseEvent } from '../../../services/firebase.service';

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const value = pathname
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]/g, '_')
      .replace(/^_/, '')
      .slice(0, 100);
    logFirebaseEvent('navigate', {
      route: value === '' ? 'home' : value,
      timestamp: new Date().toISOString(),
      userId: localStorage.getItem('userId') || 'unknown',
      // userRoles: localStorage.getItem('userRoles') || 'unknown',
    });
  }, [location]);

  return null;
}

export default RouteTracker;
